import type { EnergyResolution } from "@energyplatform/client";

// Calendar periods of the context bar.

export const PERIODS = [
  "today",
  "yesterday",
  "last7d",
  "thisMonth",
  "prevMonth",
  "yearToDate",
  "last12m",
] as const;
export type Period = (typeof PERIODS)[number];

export interface Range {
  from: Date;
  to: Date;
  /** Bucket size for energy figures over this range. */
  resolution: EnergyResolution;
}

const startOfDay = (d: Date) =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate());

/** Calendar periods in the browser's time zone; `to` is exclusive and never later than the end of the period. */
export function periodRange(period: Period, now: Date = new Date()): Range {
  const today = startOfDay(now);
  const tomorrow = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 1,
  );
  switch (period) {
    case "today":
      return { from: today, to: tomorrow, resolution: "hour" };
    case "yesterday":
      return {
        from: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 1,
        ),
        to: today,
        resolution: "hour",
      };
    case "last7d":
      return {
        from: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 6,
        ),
        to: tomorrow,
        resolution: "hour",
      };
    case "thisMonth":
      return {
        from: new Date(today.getFullYear(), today.getMonth(), 1),
        to: tomorrow,
        resolution: "day",
      };
    case "prevMonth":
      return {
        from: new Date(today.getFullYear(), today.getMonth() - 1, 1),
        to: new Date(today.getFullYear(), today.getMonth(), 1),
        resolution: "day",
      };
    case "yearToDate":
      return {
        from: new Date(today.getFullYear(), 0, 1),
        to: tomorrow,
        resolution: "month",
      };
    case "last12m":
      return {
        from: new Date(today.getFullYear(), today.getMonth() - 11, 1),
        to: tomorrow,
        resolution: "month",
      };
  }
}
